module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/logo-target-main_66ed12f.png";